import React, { useState, useEffect } from 'react';
import { updateHeaderConfig, getHeaderConfig } from '../firebase/services';
import toast from 'react-hot-toast';
import './Admin.css';

export default function ManageHeader() {
  const [logoFile, setLogoFile] = useState(null);
  const [logoPreview, setLogoPreview] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    loadHeaderConfig();
  }, []);

  const loadHeaderConfig = async () => {
    const config = await getHeaderConfig();
    if (config && config.logoUrl) {
      setLogoPreview(config.logoUrl);
    }
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setLogoFile(file);
      setLogoPreview(URL.createObjectURL(file));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!logoFile) return toast.error("Please select a logo image to update");

    setLoading(true);
    try {
      await updateHeaderConfig(logoFile);
      toast.success("Header updated successfully!");
      setLogoFile(null);
    } catch (error) {
      toast.error("Error updating header: " + error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="admin-container">
      <div className="admin-header">
        <h2>Manage Header</h2>
        <p>Update the website logo</p>
      </div>

      <div className="admin-card">
        <div className="card-header">
          <h3><ion-icon name="image-outline"></ion-icon> Logo Upload</h3>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="input-group">
            <label htmlFor="logo-upload" className="image-upload-area">
              {logoPreview ? (
                <img src={logoPreview} alt="Preview" className="image-preview" style={{maxHeight: '100px', objectFit: 'contain'}} />
              ) : (
                <>
                  <div className="upload-icon">
                    <ion-icon name="cloud-upload-outline"></ion-icon>
                  </div>
                  <p>Click to upload new logo</p>
                </>
              )}
            </label>
            <input 
              type="file" 
              id="logo-upload" 
              style={{display: 'none'}}
              accept="image/*"
              onChange={handleFileChange}
            />
          </div>

          <button type="submit" className="btn-primary" disabled={loading}>
            {loading ? 'Saving...' : (
              <>
                <ion-icon name="save-outline"></ion-icon> Update Header
              </>
            )}
          </button>
        </form>
      </div>
    </div>
  );
}
